import { createContext, useContext } from "react";

type InputSearchContextValue = {
  value: string;
  dropdownActive: boolean;
  setDropdownActive: (active: boolean) => void;
};

export const InputSearchContext = createContext<
  InputSearchContextValue | undefined
>(undefined);

export const useInputSearchContext = () => {
  const context = useContext(InputSearchContext);

  if (!context) throw new Error("Cannot find input search context");

  return context;
};
